<template>
  <div class="not-found page-content">
      <p class="oops">Coming soon!</p>
      <br>
      <router-link :to="{ name: 'home' }" class="signup px-2 md:px-8 py-1 md:py-2 bg-dcgreen text-white text-sm font-semibold uppercase font-futura">Take me home</router-link>
  </div>
</template>

<script>

export default {
  name: 'ComingSoon',
}
</script>

<style scoped lang="scss">
    .not-found {
        max-width: 500px;
        margin: auto;
        padding: 90px 0;

        .oops {
            font-size: 5rem;
        }
    }
</style>
